var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4961 7.10205H21.2044C15.1169 7.10205 11.0586 10.1458 11.0586 17.2479V31.452C11.0586 38.5541 15.1169 41.5979 21.2044 41.5979H41.4961C47.5836 41.5979 51.6419 38.5541 51.6419 31.452V17.2479C51.6419 10.1458 47.5836 7.10205 41.4961 7.10205ZM19.6826 29.4229C19.6826 30.2548 18.9926 30.9448 18.1607 30.9448C17.3287 30.9448 16.6388 30.2548 16.6388 29.4229V19.2771C16.6388 18.4451 17.3287 17.7552 18.1607 17.7552C18.9926 17.7552 19.6826 18.4451 19.6826 19.2771V29.4229ZM31.3503 30.4375C27.9818 30.4375 25.2628 27.7184 25.2628 24.35C25.2628 20.9815 27.9818 18.2625 31.3503 18.2625C34.7187 18.2625 37.4378 20.9815 37.4378 24.35C37.4378 27.7184 34.7187 30.4375 31.3503 30.4375ZM46.0617 29.4229C46.0617 30.2548 45.3718 30.9448 44.5398 30.9448C43.7079 30.9448 43.018 30.2548 43.018 29.4229V19.2771C43.018 18.4451 43.7079 17.7552 44.5398 17.7552C45.3718 17.7552 46.0617 18.4451 46.0617 19.2771V29.4229Z",
    fill: "#226B76",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05859 24.2479C4.05859 17.1458 8.11693 14.1021 14.2044 14.1021H34.4961C40.5836 14.1021 44.6419 17.1458 44.6419 24.2479V38.452C44.6419 45.5541 40.5836 48.5979 34.4961 48.5979H14.2044C8.11693 48.5979 4.05859 45.5541 4.05859 38.452V32.4255",
    stroke: "#226B76",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4367 31.3502C30.4367 27.9818 27.7176 25.2627 24.3492 25.2627C20.9808 25.2627 18.2617 27.9818 18.2617 31.3502C18.2617 34.7186 20.9808 37.4377 24.3492 37.4377C24.8971 37.4377 25.4247 37.3769 25.9117 37.2348",
    stroke: "#226B76",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1602 26.2769V36.4227",
    stroke: "#226B76",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5391 26.2769V36.4227",
    stroke: "#226B76",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessAccount);
export default __webpack_public_path__ + "static/media/access-account.07b29880160e895ffc4581330808325b.svg";
export { ForwardRef as ReactComponent };